import { clsx } from 'clsx';
import {
  createElement,
  type ElementType,
  type PropsWithChildren,
  forwardRef,
} from 'react';

import { textVariants } from './style';

import type { TextVariants } from './style';

type TextProps = PropsWithChildren<{
  className?: string;
  as?: ElementType;
  variant?: TextVariants['variant'];
  weight?: TextVariants['weight'];
  spacing?: TextVariants['spacing'];
  id?: string;
  accent?: TextVariants['accent'];
}>;

export const Text = forwardRef(
  (
    {
      as = 'p',
      className,
      variant = 'body1',
      weight = 'default',
      accent = 'none',
      spacing = 'none',
      ...props
    }: TextProps,
    ref: React.Ref<HTMLElement>
  ) =>
    createElement(as, {
      className: clsx([
        textVariants({ variant, weight, accent, spacing }),
        className,
      ]),
      ref,
      ...props,
    })
);

Text.displayName = 'Text';
